import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TextInputBox = styled(TextField)(() => ({
  borderRadius: '4px',
  width: '100%',
  padding: '0px',
  '& .MuiInputBase-input': {
    '&::placeholder': {
      fontSize: '18px',
      fontWeight: 400,
    },
  },
  '& .Mui-disabled': {
    padding: '16.5px 14px',
  },
  '& .MuiFormHelperText-root': {
    color: 'rgba(0, 0, 0, 0.6)',
    marginInline: '0px',
  },
}));
